import React from 'react';

import StaticPageLayout from './StaticPageLayout';

const PrivacyPolicy = () => (
  <StaticPageLayout
    eyebrow='Legal'
    title='Privacy Policy'
    intro='This policy explains what information Evento collects, how we use it, and the choices you have. By using Evento you agree to the practices described here.'
    updatedAt='1 July 2026'
    sections={[
      {
        heading: 'Information we collect',
        bullets: [
          'Account details you provide, such as your name, email address and phone number',
          'Professional verification documents (e.g. NIC and address proof) submitted by service providers',
          'Booking and enquiry details, including event dates, locations and messages',
          'Payment information, which is processed by our payment providers — we do not store full card details',
          'Usage and device data collected automatically to keep the service secure and improve it',
        ],
      },
      {
        heading: 'How we use your information',
        bullets: [
          'To create and manage your account and provide the Evento service',
          'To connect clients with professionals and facilitate bookings',
          'To verify professionals and maintain trust and safety on the platform',
          'To provide customer support and respond to your requests',
          'To send important service updates and, where you have opted in, marketing communications',
          'To detect, prevent and address fraud, abuse and security issues',
        ],
      },
      {
        heading: 'How we share information',
        paragraphs: [
          'We share information only as needed to run the service. We do not sell your personal information.',
        ],
        bullets: [
          'With professionals and clients as necessary to fulfil a booking or enquiry',
          'With service providers who process data on our behalf (e.g. hosting, payments), under appropriate safeguards',
          'When required by law, or to protect the rights, safety and property of Evento and its users',
        ],
      },
      {
        heading: 'Data security & retention',
        paragraphs: [
          'We use reasonable technical and organisational measures to protect your information, and retain it only as long as needed to provide the service and meet our legal obligations.',
        ],
      },
      {
        heading: 'Your rights',
        bullets: [
          'Access the personal information we hold about you',
          'Ask us to correct inaccurate information',
          'Request deletion of your account and associated data, subject to legal requirements',
          'Opt out of marketing communications at any time',
        ],
      },
      {
        heading: 'Cookies',
        paragraphs: [
          'We use cookies and similar technologies to keep you signed in, remember your preferences and understand how the service is used. You can control cookies through your browser settings.',
        ],
      },
      {
        heading: 'Changes to this policy',
        paragraphs: [
          'We may update this policy from time to time. When we do, we will revise the “Last updated” date above and, where appropriate, notify you.',
        ],
      },
      {
        heading: 'Contact us',
        paragraphs: [
          'If you have questions about this policy or your data, contact us at privacy@evento.lk.',
        ],
      },
    ]}
  />
);

export default PrivacyPolicy;
